import Vue from 'vue';

const costCenterModule = {
	actions: {
		async loadCostCenter(store, { context, subsidiaryId }) {
			let { data: costsCenter } = await context.$http.get(`cost-center/${subsidiaryId}/subsidiary`);
			costsCenter = costsCenter.map((c) => {
				const newCost = { ...c };
				const index = c.costCenterId ? costsCenter.findIndex(o => o.id === c.costCenterId) : -1;
				newCost.fatherAccount = index > -1 ? costsCenter[index].name : null;
				return newCost;
			});
			store.commit('setCostsCenter', [...costsCenter]);
		},
	},
	getters: {
		getCostsCenters(state) {
			return state.costsCenters;
		},
	},
	mutations: {
		setCostsCenter(state, costsCenters) {
			Vue.set(state, 'costsCenters', costsCenters);
		},
	},
	state: {
		costsCenters: [],
	},
};

export default costCenterModule;



// WEBPACK FOOTER //
// ./src/store/modules/costCenter/costCenterModule.js